const User = {
    state: {
        id: sessionStorage.getItem('App.UserId') || '',
        token: sessionStorage.getItem('App.UserToken') || '',
        name: sessionStorage.getItem('App.UserName') || '',
        role: sessionStorage.getItem('App.UserRole') || '',
        level: sessionStorage.getItem('App.UserLevel') || '',
        info: JSON.parse(sessionStorage.getItem('App.UserInfo') || '{}')
    },
    mutations: {
        signin(state, payload) {
            state.id = payload.uid
            state.token = payload.token
            state.name = payload.name
            state.role = payload.role
            state.level = payload.level
            state.info = payload

            sessionStorage.setItem('App.UserId', payload.uid)
            sessionStorage.setItem('App.UserToken', payload.token)
            sessionStorage.setItem('App.UserName', payload.name)
            sessionStorage.setItem('App.UserRole', payload.role)
            sessionStorage.setItem('App.UserLevel', payload.level)
            sessionStorage.setItem('App.UserInfo', JSON.stringify(payload))
        },
        signout(state) {
            state.id = ''
            state.token = 'Guest'
            state.name = ''
            state.role = ''
            state.info = {}
            sessionStorage.clear()
        }
    }
}

export default User
